/* eslint-disable max-len */
import env from '../config/env';
import ApiService from './ApiService';
import localStorageFacade, { LocalStorageKeys } from '../utils/localStorageFacade';

const consentApi = '/v0/consent';

const getConsents = (data) => ApiService.httpClient.post(
  `${env.api.url}${consentApi}/search`,
  data,
  {
    headers: {
      Authorization: `Bearer ${localStorageFacade.get(LocalStorageKeys.AUTH_TOKEN)}`,
    },
  },
);

const createConsents = (data) => ApiService.httpClient.post(
  `${env.api.url}${consentApi}/create`,
  data,
  {
    headers: {
      Authorization: `Bearer ${localStorageFacade.get(LocalStorageKeys.AUTH_TOKEN)}`,
    },
  },
);

const ConsentService = {
  getConsents,
  createConsents,
};

export default ConsentService;
